import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=31d8889e&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
import style0 from "./Loading.vue?vue&type=style&index=0&id=31d8889e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8889e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d8889e')) {
      api.createRecord('31d8889e', component.options)
    } else {
      api.reload('31d8889e', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=31d8889e&scoped=true", function () {
      api.rerender('31d8889e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Loading.vue"
export default component.exports